import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getBuyerPaidEmd } from "../../../../../redux/action/buyer";
import {
  convertTo12HourFormat,
  NoItemsLeftInTable,
} from "../../../../../helpers/helpers";
import LoadingSkeleton from "../../../../loader/TableLoader";
import { useNavigate } from "react-router-dom";
import Paginations from "../../../../commanPage/pagination/Paginations";

function PaidEmd({ searchTraderList, auctionFilter }) {
  const totalNumberRow = 30;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [emdValue, setEmdValue] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [initialPaidEmdData, setInitialPaidEmdData] = useState([]);
  const { paidEmdData, loadings } = useSelector((state) => state?.buyerPiadEmd);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageVisited, setMaxPageVisited] = useState(1);

  useEffect(() => {
    dispatch(getBuyerPaidEmd(currentPage, totalNumberRow, auctionFilter));
  }, [dispatch, auctionFilter, currentPage, totalNumberRow]);

  useEffect(() => {
    setEmdValue(paidEmdData);
    setInitialPaidEmdData(paidEmdData);
  }, [paidEmdData]);

  useEffect(() => {
    const searchLower = searchTraderList?.toLowerCase();
    if (!searchLower?.trim()) {
      setEmdValue([...initialPaidEmdData]);
    } else {
      const filteredDetails = initialPaidEmdData?.filter((item) =>
        [
          "description",
          "status",
          "industry",
          "offerSchedule",
          "EMDAmount",
          "description",
          "auctionType",
        ].some((field) =>
          field === "offerSchedule"
            ? ["startingTime", "endingTime"].some((subField) => {
              const fieldValue = item[field]?.[subField];
              if (subField === "startingTime" || subField === "endingTime") {
                return convertTo12HourFormat(fieldValue)
                  ?.toLowerCase()
                  ?.includes(searchLower);
              }
              return fieldValue?.toLowerCase()?.includes(searchLower);
            })
            : item[field]?.toLowerCase()?.includes(searchLower)
        )
      );
      setEmdValue(filteredDetails);
    }
  }, [searchTraderList, initialPaidEmdData]);

  useEffect(() => {
    setMaxPageVisited(1);
    setCurrentPage(1);
  }, [auctionFilter]);

  const memoizedBuyerPaidEmd = useMemo(() => emdValue, [emdValue]);

  if (loadings) {
    return (
      <div className="valign-wrapper justify-center cover white">
        <LoadingSkeleton
          headerData={[
            "Lots ID",
            "Description",
            "Lots Timings",
            "Actions",
          ]}
        />
      </div>
    );
  }

  return (
    <>
      <div className={`${!isTablet && " table-container-style"}`}>
        {memoizedBuyerPaidEmd?.length <= 0 && searchTraderList !== "" ? (
          <NoItemsLeftInTable />
        ) : (
          <table
            className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
          >
            <thead className="grey lighten-4">
              <tr>
                <th>Lot Id</th>
                <th>Description</th>
                <th>Lot Time</th>
                <th>EMD Amount</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {memoizedBuyerPaidEmd?.map((items, index) => (
                <tr key={items._id}>
                  <td>{index + 1}</td>
                  <td style={{ width: !isTablet && "350px" }}>
                    <p className="NoOfline" style={{ WebkitLineClamp: 1 }}>
                      {items.description}
                    </p>
                  </td>
                  {/* <td>
                    <span
                      className={`${items?.auctionType === "reverseAuction"
                        ? "auctiontype-reverse"
                        : "auctiontype-forward"
                        }`}
                    >
                      {auctionTypeStyle(items?.auctionType)}{" "}
                    </span>
                  </td> */}
                  <td>{`${convertTo12HourFormat(
                    items?.offerSchedule?.startTimeAndDate
                  )} - ${convertTo12HourFormat(
                    items?.offerSchedule?.endTimeAndDate
                  )}`}</td>
                  <td>{items?.EMDAmount}</td>
                  <td>
                    <span
                      className="material-icons  cercle-purple-text  pointer"
                      onClick={() =>
                        navigate(`/offer-details/${items?.auction}/${items._id}`)
                      }
                    >
                      visibility
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {memoizedBuyerPaidEmd?.length === 0 && searchTraderList === "" && (
          <NoItemsLeftInTable />
        )}
      </div>

      {memoizedBuyerPaidEmd?.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalNumberRow={totalNumberRow}
          totalData={memoizedBuyerPaidEmd?.length}
          maxPageVisited={maxPageVisited}
          setMaxPageVisited={setMaxPageVisited}
        />
      )}
    </>
  );
}

export default PaidEmd;
